/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmModelLibraryModelsPlantingStandardModel } from '../model';
/**
 * PlantingStandardApi - axios parameter creator
 * @export
 */
export const PlantingStandardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get planting standards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantingStandardGetPlantingStandards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/plantingstandards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlantingStandardApi - functional programming interface
 * @export
 */
export const PlantingStandardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlantingStandardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get planting standards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async plantingStandardGetPlantingStandards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GmModelLibraryModelsPlantingStandardModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.plantingStandardGetPlantingStandards(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PlantingStandardApi.plantingStandardGetPlantingStandards']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PlantingStandardApi - factory interface
 * @export
 */
export const PlantingStandardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlantingStandardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get planting standards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        plantingStandardGetPlantingStandards(options?: any): AxiosPromise<Array<GmModelLibraryModelsPlantingStandardModel>> {
            return localVarFp.plantingStandardGetPlantingStandards(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlantingStandardApi - object-oriented interface
 * @export
 * @class PlantingStandardApi
 * @extends {BaseAPI}
 */
export class PlantingStandardApi extends BaseAPI {
    /**
     * 
     * @summary Get planting standards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlantingStandardApi
     */
    public plantingStandardGetPlantingStandards(options?: RawAxiosRequestConfig) {
        return PlantingStandardApiFp(this.configuration).plantingStandardGetPlantingStandards(options).then((request) => request(this.axios, this.basePath));
    }
}

